// extracted by mini-css-extract-plugin
export default {"wrapper":"AppName_wrapper__5Fz7S","appLogo":"AppName_appLogo__I50XA","withName":"AppName_withName__H3SMR","appName":"AppName_appName__h7LtC"};